import { PageHeader } from '@celltrak/ui-components';

import RejectedList from '../RejectedList';
import RejectedFilterBar from '../RejectedFilterBar';
import RejectedFooter from '../RejectedFooter';

import styles from './RejectedSummary.module.scss';
import useRejectedSummary from './hooks';

const RejectedSummary = () => {
  const { rejectedReports, isLoading } = useRejectedSummary();

  return (
    <div className={styles.rejectedSummaryContainer}>
      <div>
        <PageHeader title="Rejected Summary" />
        <RejectedFilterBar />
      </div>
      <RejectedList rejectedReports={rejectedReports} loading={isLoading} />
      <RejectedFooter />
    </div>
  );
};

export default RejectedSummary;
